module.exports = __webpack_public_path__ + "static/media/starlink_logo.28756d25.svg";